import React from 'react';
import _ from 'lodash';
import {Grid} from 'semantic-ui-react';
import {TextBoxField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';

export class GreenspaceAcreage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (this.props.inventoryItem === undefined) return <p>No data available</p>;
    if (!this.props.inventoryItem.payload) return <p>No data available</p>;
    if (!this.props.inventoryItem.payload.greenspaceAcreage)
      return <p>No data available</p>;
    const {displayType} = this.props;
    const {greenspaceAcreage} = this.props.inventoryItem.payload;

    return (
      <div id="greenspace-acreage">
        <Grid>
          <Grid.Row>
            <Grid.Column mobile={16} computer={16}>
              <div id="greenspace-acreage-acreage-turned-to-greenspace">
                {displayType === 'view' ? (
                  <React.Fragment>
                    <p className="label">
                      What is the proposed area, in acres, to be converted to green space
                      for this site?
                    </p>
                    {greenspaceAcreage.acreageTurnedToGreenspace}
                  </React.Fragment>
                ) : (
                  <div className="util--full-width ui form">
                    <TextBoxField
                      id="acreage-turned-to-greenspace-control"
                      label="What is the proposed area, in acres, to be converted to green space for this site?"
                      title="What is the proposed area, in acres, to be converted to green space for this site?"
                      name="payload.greenspaceAcreage.acreageTurnedToGreenspace"
                      value={greenspaceAcreage.acreageTurnedToGreenspace}
                      handleChange={this.props.handleChangeNumber}
                      handleBlur={this.props.handleBlur}
                      displayError={this.props.displayError(
                        'payload.greenspaceAcreage.acreageTurnedToGreenspace'
                      )}
                      errorMessages={this.props.getErrorMessage(
                        'payload.greenspaceAcreage.acreageTurnedToGreenspace',
                        'What is the proposed area, in acres, to be converted to green space for this site?'
                      )}
                    />
                  </div>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default GreenspaceAcreage;
